<template>
<div style="margin-top: 250px">

  <v-card color="rgba(217, 217, 217, 0.8)">
    <v-card-title >
        <v-row>
          <v-col cols="6">
            <v-text-field
              outlined 
              dense
              rounded small
              v-model="HID"
              label="HID"
              width="100px"
              disabled
            ></v-text-field>
          </v-col>

          <v-col>
            <v-btn
              color="error"
              v-if="role == 'RESPONDENT'"
              @click="logKeluar()"
            >
            Log Keluar
            </v-btn>
          </v-col>
        </v-row>
    </v-card-title>
</v-card>

<v-card>
    <v-card-title >
        <v-row>
          <v-btn color="primary white--text" @click="showBorangTambahAhliIsiRumah=true"><span class="material-icons">add</span>{{$t('Tambah Ahli Isi Rumah')}}</v-btn>
                  <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          
                          <v-icon
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>1. Pengisian nombor ahli isi rumah hanyalah untuk orang yang layak sebagai ahli biasa.</span>
                        <br>
                        <span>2.  Ahli Isi Rumah Biasa ditakrifkan sebagai seorang atau sekumpulan orang yang bersaudara atau tidak bersaudara yang biasanya tinggal bersama dan membuat peruntukan yang sama untuk makanan dan keperluan hidup yang lain</span>
        
                  </v-tooltip>
        </v-row>
      </v-card-title>
</v-card>

<v-card>
    <v-card-title >
        <v-row>
          <v-col cols="2">
            <span style="color:green;font-weight:bold;font-size: small;"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn> -  {{$t('Siap Diisi')}}</span>
          </v-col>

          <v-col cols="2">
            <span style="color:red;font-weight:bold;font-size: small;"><v-btn color="red" rounded small><v-icon>mdi-close-thick</v-icon></v-btn> - {{$t('Belum Diisi')}}</span>
          </v-col>

          <v-col cols="2">
            <span style="color:#FFC300;font-weight:bold;font-size: small;"><v-btn color="#FFC300" rounded small><v-icon color="white">mdi-brightness-1</v-icon></v-btn> - {{$t('Pilihan')}}</span>
          </v-col>

          <v-col cols="2">
            <span style="color:black;font-weight:bold;font-size: small;"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn> - {{$t('Tidak Perlu Diisi')}}</span>
          </v-col>
        </v-row>
      </v-card-title>
</v-card>



<v-card >

  <v-card-title style="text-decoration: underline overline;">
   HIS - Senarai Ahli Isi Rumah
  </v-card-title>  

  <v-card-text>

      <v-simple-table 
      fixed-header
      dense
      >

      <thead>
        <tr>
          <th ><strong>Nombor Ahli Isi Rumah</strong></th>
          <th        
            v-for="(item,index) in irData.dataJR5" 
            :key="index"
            >
              <v-btn 
                depressed
                dense
                @click="selectedNOAIR(item)" 
                style="cursor: pointer;"
                color="primary"
                >
                {{ item.NOAIR }} : {{ item.Nama }}
              </v-btn>
          </th>
        </tr>
      </thead>

      <tbody>

        <tr>
          <td >Perhubungan Dengan Ketua Isi Rumah</td>
          <td
            v-for="(item,index) in irData.dataJR5" 
            :key="index"
          >
            {{item.PKIR}} - {{item.keterangan}}
          </td>
        </tr>

        <!-- JR2 -->
        <tr style="background: #CDCDCD">
          <td>Butir - butir Pengenalan (JR2)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >

                <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                  <span v-if="irData.dataJR2[0].NOIC !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JR2')"><v-icon>mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataJR2[0].NOIC === null" style="color:red;font-weight:bold"><v-btn color="red" rounded  small @click="testClick(item,'JR2')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>

                <!-- JR2 Kalau NOIR bukan 01 paparkan ini -->
                <div v-if="item.NOAIR != '01'">
                  <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                </div>

            </td>
        </tr>

        <!-- JRA -->
        <tr>
          <td>Maklumat Isi Rumah (JRA)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRA -->
              <div style="cursor: pointer;">
                <span v-if="item.PP !== null"  style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRC')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.PP === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRC')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD"> 
          <td>Maklumat Pendapatan Isi Rumah (HK1) <strong> - JIKA BERKAITAN</strong></td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB - HK1 -->
              <div style="cursor: pointer;">
                <span v-if="item.INCS01 !== null" @click="testClick(item,'hk1')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.INCS01 === null" @click="testClick(item,'JRB')" style="color:red;font-weight:bold"><v-btn color="#FFC300" rounded small><v-icon color="white">mdi-alpha-o-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr>
          <td> Aktiviti Pertanian (HK2) <strong> - JIKA BERKAITAN</strong></td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB - HK2 -->
              <div style="cursor: pointer;">
                <span v-if="item.HK2INCS21A_iii !== null && item.HK2INCS21A_iii !== ''" @click="testClick(item,'hk2')"  style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.HK2INCS21A_iii === null || item.HK2INCS21A_iii === ''" @click="testClick(item,'JRB')" style="color:red;font-weight:bold"><v-btn color="#FFC300" rounded small><v-icon color="white">mdi-alpha-o-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD">
          <td> Aktiviti Perikanan (HK3) <strong> - JIKA BERKAITAN</strong></td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB - HK3 -->
              <div style="cursor: pointer;">
                <span v-if="item.HK3INCS21a !== null && item.HK3INCS21a !== '0' && item.HK3INCS21a !== ''" @click="testClick(item,'hk3')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.HK3INCS21a === null || item.HK3INCS21a === '0' || item.HK3INCS21a === ''" @click="testClick(item,'JRB')" style="color:red;font-weight:bold"><v-btn color="#FFC300" rounded small><v-icon color="white">mdi-alpha-o-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr>
          <td>  Aktiviti ICT (HK4) <strong> - JIKA BERKAITAN</strong></td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB - HK4 -->
              <div style="cursor: pointer;">
                  <span v-if="item.HK4INCS21b !== null && item.HK4INCS21b !== '0' && item.HK4INCS21b !== ''" @click="testClick(item,'hk4')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.HK4INCS21b === null || item.HK4INCS21b === '0' || item.HK4INCS21b === ''" @click="testClick(item,'JRB')" style="color:red;font-weight:bold"><v-btn color="#FFC300" rounded small><v-icon color="white">mdi-alpha-o-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD">
          <td> Aktiviti Pengangkutan Bukan Pertanian & Bukan ICT (HK5) <strong> - JIKA BERKAITAN</strong></td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB - HK5 -->
              <div style="cursor: pointer;">
                  <span v-if="item.HK5INCS21d !== null && item.HK5INCS21d !== '0' && item.HK5INCS21d !== ''" @click="testClick(item,'hk5')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.HK5INCS21d === null || item.HK5INCS21d === '0' || item.HK5INCS21d === ''" @click="testClick(item,'JRB')" style="color:red;font-weight:bold"><v-btn color="#FFC300" rounded small><v-icon color="white">mdi-alpha-o-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr>
          <td> Aktiviti Lain - lain Bukan Pertanian & Bukan ICT  (HK6) <strong> - JIKA BERKAITAN</strong></td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB - HK6 -->
              <div style="cursor: pointer;">
                  <span v-if="item.HK6INCS21e !== null && item.HK6INCS21e !== '0' && item.HK6INCS21e !== ''" @click="testClick(item,'hk6')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.HK6INCS21e === null || item.HK6INCS21e === '0' || item.HK6INCS21e === ''" @click="testClick(item,'JRB')" style="color:red;font-weight:bold"><v-btn color="#FFC300" rounded small><v-icon color="white">mdi-alpha-o-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD">
          <td>  Kegunaan Sendiri (HK7)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
               <!-- HK7 -->
                <!-- Kalau NOIR 01 paparkan ini -->
                <!-- Open link -->  
                 <!-- <div style="cursor: pointer;">
                  <span v-if="item.INCS21KS !== null && item.INCS21KS !== '0' && item.INCS21KS !== ''" @click="testClick(item,'HK7')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.INCS21KS === null || item.INCS21KS === '0' || item.INCS21KS === ''" @click="testClick(item,'HK7')" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div> -->
                <div v-if="item.NOAIR == '01'" style="cursor: pointer;">
                  <span v-if="item.INCS21KS !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'HK7')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.INCS21KS === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'HK7')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <!-- Kalau NOIR bukan 01 paparkan ini -->
                <div v-if="item.NOAIR != '01'">
                  <div v-if="item.PP == 1">
                    <span v-if="item.INCS21KS !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'HK7')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                    <span v-if="item.INCS21KS === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'HK7')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                  </div>
                  <div v-if="item.PP == 2 || item.PP == null ">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
                </div>
            </td>
        </tr>

        <tr>
          <td>  Pendapatan Lain Diperoleh (HK8)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- HK8 -->
              <!-- Open link -->  
              <!-- <div style="cursor: pointer;">
                  <span v-if="item.INCS34 !== null && item.INCS34 !== '0' && item.INCS34 !== ''" @click="testClick(item,'HK8')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.INCS34 === null || item.INCS34 === '0' || item.INCS34 === ''" @click="testClick(item,'HK8')" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div> -->
              <!-- Kalau NOIR 01 paparkan ini -->
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <span v-if="item.INCS34 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'HK8')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.INCS34 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'HK8')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                  <div v-if="item.PP == 1">
                    <span v-if="item.INCS34 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'HK8')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                    <span v-if="item.INCS34 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'HK8')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                  </div>
                  <div v-if="item.PP == 2 || item.PP == null ">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
                </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD">
          <td> Pindahan Semasa Diterima (JRB)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB modul pindahan semasa diterima -->
              <!-- Open link -->  
              <!-- <div style="cursor: pointer;">
                  <span v-if="item.INCS05 !== null && item.INCS05 !== '0' && item.INCS05 !== ''" @click="testClick(item,'JRBpindahan')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.INCS05 === null || item.INCS05 === '0' || item.INCS05 === ''" @click="testClick(item,'JRBpindahan')" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div> -->

              <div v-if="item.NOAIR == '01'" style="cursor: pointer;">
                <span v-if="item.INCS05 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRBpindahan')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.INCS05 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRBpindahan')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
               <div v-if="item.NOAIR != '01'">
                  <div v-if="item.PP == 1">
                    <span v-if="item.INCS05 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRBpindahan')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                    <span v-if="item.INCS05 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRBpindahan')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                  </div>
                  <div v-if="item.PP == 2 || item.PP == null ">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
                </div>
            </td>
        </tr>

        <!-- <tr v-show="checkSample">
          <td> Penerimaan Bulan Sebelumnya (JRB)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
             
              <div v-if="item.NOAIR == '01'" @click="testClick(item,'IMBANGAN')" style="cursor: pointer;">
                <div v-if="irData.dataPER9.length > 0">
                  <span v-if="irData.dataPER9[0].INCS09 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataPER9[0].INCS09 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataPER9.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
             
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr> -->

        <tr v-show="checkSample">
          <td> Penerimaan Bulan Sebelumnya (JRB)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >

              <!-- <div v-if="item.PP == '1'" @click="testClick(item,'IMBANGAN')" style="cursor: pointer;">
                <div v-if="irData.dataPER9[index]">
                    <span v-if="irData.dataPER9[index].INCS09 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                    <span v-if="irData.dataPER9[index].INCS09 == null" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span> 
                </div>
                <div v-else>
                   <span style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div> -->
                <div v-if="item.PP == '1'"  style="cursor: pointer;">
                  <div v-if="irData.dataPER9.length > 0">
                    <div v-for="(itemz,indexx) in irData.dataPER9" :key="indexx">
                      <div v-if="userExists(item.NOAIR) == false">
                        <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'IMBANGAN')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                      </div>
                      <div v-if="userExists(item.NOAIR) == true">
                        <div v-if="item.NOAIR == itemz.NOAIR">
                          <span v-if="itemz.INCS09 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'IMBANGAN')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                          <span v-if="itemz.INCS09 == null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'IMBANGAN')"><v-icon >mdi-close-thick</v-icon></v-btn></span> 
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="irData.dataPER9.length <= 0">
                    <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'IMBANGAN')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                  </div>
                </div>


              <div v-if="item.PP != '1'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr >
          <td> Penerimaan One-off (JRB)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB penerimaan one-off -->
              <!-- Kalau NOIR 01 paparkan ini -->
              <div v-if="item.NOAIR == '01'" >
                  <div v-if="item.PP == 1">
                    <div v-if="item.S20 == 1">
                      <span v-if="item.INCS10 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRB1off')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                      <span v-if="item.INCS10 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRB1off')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                    </div>
                    <div v-if="item.S20 == 2">
                       <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                    </div>
                  </div>
                  <div v-if="item.PP == 2">
                    <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
                   <div v-if="item.PP == null">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
              </div>
              <!-- Open link -->  
              <!-- <div style="cursor: pointer;">
                  <span v-if="item.INCS10 !== null && item.INCS10 !== '0' && item.INCS10 !== ''" @click="testClick(item,'JRB1off')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.INCS10 === null || item.INCS10 === '0' || item.INCS10 === ''" @click="testClick(item,'JRB1off')" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div> -->
              <!-- Kalau NOIR bukan 01 , PP = 1 & 2 paparkan ini -->
             <div v-if="item.NOAIR != '01'">
                  <div v-if="item.PP == 1">
                    <div v-if="item.S20 == 1">
                      <span v-if="item.INCS10 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRB1off')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                      <span v-if="item.INCS10 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRB1off')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                    </div>
                    <div v-if="item.S20 == 2">
                       <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                    </div>
                  </div>
                   <div v-if="item.PP == 2">
                    <div v-if="item.S20 == 1">
                      <span v-if="item.INCS10 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRB1off')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                      <span v-if="item.INCS10 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRB1off')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                    </div>
                    <div v-if="item.S20 == 2">
                       <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                    </div>
                  </div>
                  <div v-if="item.PP == null">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
                </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD">
          <td> Pindahan Semasa Dibayar (JRC)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRB pindahan semasa dibayar -->
              <!-- Kalau NOIR 01 paparkan ini -->
              <div v-if="item.NOAIR == '01'" >
               <div v-if="item.PP == 1">
                    <span v-if="item.TP74 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRCPSD')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                    <span v-if="item.TP74 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRCPSD')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
               </div>
               <div v-if="item.PP == 2 || item.PP == null ">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
               </div>
              </div>

               <!-- Open link -->  
              <!-- <div style="cursor: pointer;">
                  <span v-if="item.TP74 !== null && item.TP74 !== '0' && item.TP74 !== ''" @click="testClick(item,'JRCPSD')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="item.TP74 === null || item.TP74 === '0' || item.TP74 === ''" @click="testClick(item,'JRCPSD')" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div> -->

              <!-- Kalau NOIR bukan 01 paparkan ini -->
             <div v-if="item.NOAIR != '01'">
                  <div v-if="item.PP == 1">
                    <span v-if="item.TP74 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRCPSD')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                    <span v-if="item.TP74 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRCPSD')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                  </div>
                  <div v-if="item.PP == 2 || item.PP == null ">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
                </div>
            </td>
        </tr>

        <!-- <tr >
          <td> Maklumat Tambahan Untuk Pinjaman Kewangan (JRD)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            > -->
              <!-- JRD -->
              <!-- Kalau NOIR 01 paparkan ini -->
              <!-- <div v-if="item.NOAIR == '01'" @click="testClick(item,'JRD')">
                <span v-if="item.Leii !== null" @click="testClick(item,'JRD')" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.Leii === null" @click="testClick(item,'JRD')" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div> -->
              <!-- Kalau NOIR bukan 01 paparkan ini -->
             <!-- <div v-if="item.NOAIR != '01'" @click="testClick(item,'JRD')">
                  <div v-if="item.PP == 1">
                    <span v-if="item.Leii !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                    <span v-if="item.Leii === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
                  </div>
                  <div v-if="item.PP == 2 || item.PP == null">
                   <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
                  </div>
                </div>
            </td>
        </tr> -->

        <!-- Pendapatan Ahli Isi Rumah -->
        <!-- <tr style="background: #CDCDCD"> -->
        <!-- <tr >
          <td> Ringkasan Pendapatan Ahli Isi Rumah (AIR)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            > -->
              <!-- JRD -->
              <!-- Kalau NOIR 01 paparkan ini -->
              <!-- <div v-if="item.NOAIR == '01'" >
                <span v-if="item.TP74 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'ringkasanpendapatanAIR')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                <span v-if="item.TP74 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'ringkasanpendapatanAIR')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
              </div> -->
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <!-- <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div> -->
            <!-- </td>
        </tr> -->

        <tr >
          <td> Seksyen 1 (JRE) : Pendidikan</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRE Seksyen 1 ISMA-->
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <div v-if="irData.dataJRE.length > 0">
                  <span v-if="irData.dataJRE[0].TASm !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRE1')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataJRE[0].TASm === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRE1')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataJRE.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRE1')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD">
          <td> Seksyen 2 (JRE) : Kesihatan</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRE Seksyen 2 ISMA-->
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <div v-if="irData.dataJRE.length > 0">
                  <span v-if="irData.dataJRE[0].JKS !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRE2')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataJRE[0].JKS === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRE2')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataJRE.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRE2')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr >
          <td> Seksyen 3 (JRF) : Perumahan</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRF Seksyen 3 ISMA-->
              <div v-if="item.NOAIR == '01'" style="cursor: pointer;">
                <div v-if="irData.dataJRE.length > 0">
                  <span v-if="irData.dataJRE[0].KS !== null " style="color:green;font-weight:bold"><v-btn color="green" rounded small  @click="testClick(item,'JRF3')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataJRE[0].KS === null " style="color:red;font-weight:bold"><v-btn color="red" rounded small  @click="testClick(item,'JRF3')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataJRE.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small  @click="testClick(item,'JRF3')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr style="background: #CDCDCD">
          <td> Seksyen 4 (JRG) : Peralatan & Kemudahan Isi Rumah</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRG Seksyen 4 HANI-->
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <div v-if="irData.dataJRE.length > 0">
                  <span v-if="irData.dataJRE[0].PR31 !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRG')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataJRE[0].PR31 === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRG')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataJRE.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRG')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr >
           <td> Seksyen 5 (JRH) : Kebolehcapaian Makanan</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- JRH Seksyen 5 -->
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <div v-if="irData.dataJRE.length > 0">
                  <span v-if="irData.dataJRE[0].BBM !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JRH')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataJRE[0].BBM === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRH')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataJRE.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JRH')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

         <tr style="background: #CDCDCD">
          <td> Food Waste </td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <div v-if="irData.dataFoodwaste.length > 0">
                  <span v-if="irData.dataFoodwaste[0].FAH !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'foodwaste')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataFoodwaste[0].FAH === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'foodwaste')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataFoodwaste.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'foodwaste')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
                <!--Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>
       

        <tr style="background: #CDCDCD" v-show="checkSample">
          <td> Perbelanjaan (sebulan)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- PERBELANJAAN -->
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <div v-if="irData.dataPB.length > 0">
                  <span v-if="irData.dataPB[0].jumBelanjaA !== null" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'PERBELANJAAN')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataPB[0].jumBelanjaA === null" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'PERBELANJAAN')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataPB.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'PERBELANJAAN')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <tr v-show="checkSample2">
          <td> JR2 Imbangan (Kegunaan pejabat)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <!-- PERBELANJAAN -->
              <div v-if="item.NOAIR == '01'"  style="cursor: pointer;">
                <div v-if="irData.dataPB.length > 0">
                  <span v-if="irData.dataPB[0].jumBelanjaA !== null || irData.dataPB[0].jumBelanjaA !== '0'" style="color:green;font-weight:bold"><v-btn color="green" rounded small @click="testClick(item,'JR2Imbangan')"><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataPB[0].jumBelanjaA === null || irData.dataPB[0].jumBelanjaA === '0'" style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JR2Imbangan')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataPB.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" rounded small @click="testClick(item,'JR2Imbangan')"><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
              <!-- Kalau NOIR bukan 01 paparkan ini -->
              <div v-if="item.NOAIR != '01'">
                <span style="color:black;font-weight:bold"><v-btn color="black" rounded small><v-icon color="white">mdi-minus-circle</v-icon></v-btn></span>
              </div>
            </td>
        </tr>

        <!-- <tr v-show="checkSample2" style="background: #CDCDCD">
          <td> BLOK 7 (Imbangan)</td>
            <td
              v-for="(item,index) in irData.dataJR5" 
              :key="index"
            >
              <div style="cursor: pointer;">
                <div v-if="irData.dataBLK_VII_IMBANG.length > 0">
                  <span v-if="irData.dataBLK_VII_IMBANG.INCS09 !== null || irData.dataBLK_VII_IMBANG.INCS09 !== '0'" style="color:green;font-weight:bold"><v-btn  @click="testClick(item,'Blok7Imbangan')" color="green" rounded small><v-icon >mdi-check-outline</v-icon></v-btn></span>
                  <span v-if="irData.dataBLK_VII_IMBANG.INCS09 === null || irData.dataBLK_VII_IMBANG.INCS09 === '0'" style="color:red;font-weight:bold"><v-btn  @click="testClick(item,'Blok7Imbangan')" color="red" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
                <div v-if="irData.dataBLK_VII_IMBANG.length <= 0">
                  <span style="color:red;font-weight:bold"><v-btn color="red" @click="testClick(item,'Blok7Imbangan')" rounded small><v-icon >mdi-close-thick</v-icon></v-btn></span>
                </div>
              </div>
            </td>
        </tr> -->
        <!-- 
        <v-col>
        </v-col>
        <v-col>
        </v-col>
        <v-col>
        </v-col> -->

      </tbody>
    </v-simple-table>

  </v-card-text>
 
</v-card>

<v-row class="ml-4 mt-4 mb-4" max-width="auto">
  <v-col>
    <v-btn
      color="success"
      @click="semakanData()"
      >
      {{$t('semakan pengisian')}}
    </v-btn>
  </v-col>
</v-row>
    

<!-- Form Tambah Ahli Isi Rumah -->
 <v-dialog
      v-model="showBorangTambahAhliIsiRumah"
      max-width="1000"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{$t('Tambah Ahli Isi Rumah')}}
        </v-card-title>

        <v-card-text >
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row>
              <v-col cols="3">
                Nombor Ahli Isi Rumah
                  <v-text-field
                  outlined dense
                  v-model="tambahNOAIR"
                  :error-messages="noairErrors"
                  :success-messages="noairSuccess"
                  type="number"
                  :min="0"
                  ></v-text-field> 
              </v-col>

              <v-col>
                Nama
                  <v-text-field
                  outlined dense
                  v-model="tambahNama"
                  required
                  :rules="[rules.required]"
                  ></v-text-field> 
              </v-col>
              <!-- <v-col>
                Nombor I/C
                  <v-text-field
                  outlined dense
                  v-model="tambahNOIC"
                  ></v-text-field> 
              </v-col> -->
            </v-row>

            <v-row>
              <v-col>
                S2 : Perhubungan Dengan Ketua Isi Rumah
                <v-select
                  :items="hubunganIsiRumah"
                  :item-text="item => item.id +' - '+ item.desc"
                  return-object
                  solo
                  dense
                  v-model="tambahPKIR"
                  :rules="[rules.required]"
                  :disabled="disabledPKIR"
                ></v-select>
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
              color="warning"
              @click="showBorangTambahAhliIsiRumah = false"
              >
              {{$t('batal')}}
            </v-btn>

            <v-btn
            :disabled="butangSimpanAhliIsiRumah"
            color="success"
            @click="simpanAhliIsiRumah()"
            >
            {{$t('simpan')}}
            </v-btn>
        </v-card-actions>
      </v-card>
</v-dialog>

<!-- PopUp click NOAIR -->
<v-dialog
      v-model="noairClick"
      max-width="300"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          <!-- <v-row>
            <v-col cols="12" sm="8">
              <v-text-field
                      min="0"
                      maxlength="2"
                      outlined
                      dense
                      :items="selectedNOAIRdata.NOAIR"
                      label="NOAIR"
                      v-model="kemaskiniNOAIR">
              NOAIR : {{selectedNOAIRdata.NOAIR}} 
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="8">
              <v-autocomplete
                      min="0"
                      maxlength="2"
                      outlined
                      dense
                      :items="selectedNOAIRdata.PKIR"
                      label="PKIR"
                      v-model="kemaskiniPKIR"
                      :item-text="item => item.id +' - '+ item.desc"
                      item-value="id"
                      return-object>
              PKIR : {{selectedNOAIRdata.PKIR}} 
              </v-autocomplete>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col cols="12" sm="8">
              NOAIR : {{selectedNOAIRdata.NOAIR}}
            </v-col> 
            <v-col cols="12" sm="8">
              PKIR : {{selectedNOAIRdata.PKIR}}
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="warning"
            @click="noairClick = false"
            >
           {{$t('batal')}}
          </v-btn>

          <v-btn
          color="error"
          @click="dialogDelete = true"
          >
          {{$t('padam')}}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
</v-dialog>

<!-- error dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>


 <!-- DIalog HID -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogHID"
      persistent
      max-width="450"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{$t('Tiada HID Dijumpai!')}}
        </v-card-title>
        <v-card-text>{{$t('Sila masukkan Nombor HID')}}
          <br>
            <v-text-field
              outlined 
              dense
              rounded small
              v-model="nomborHID"
              label="HID"
            ></v-text-field>
            <v-text-field
              outlined 
              dense
              rounded small
              v-model="tahunCarianHID"
              label="Tahun"
            ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="yellow darken-1"
            rounded small
            @click="tutupDialogTiadaHID"
          >
            {{$t('batal')}}
          </v-btn>
          <v-btn
            color="green darken-1"
            rounded small
            @click="submitHID"
          >
            {{$t('hantar')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- DIalog Padam -->
 <v-row justify="center">
    <v-dialog
      v-model="dialogDelete"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
         {{$t("Adakah anda pasti?")}}
        </v-card-title>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="noairClick = false;dialogDelete = false;"
          >
           {{$t('batal')}}
          </v-btn>
          <v-btn
            color="error"
            @click="padam(selectedNOAIRdata.JR5ID,selectedNOAIRdata.HID,selectedNOAIRdata.NOAIR)"
          >
            {{$t('padam')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

    <!-- DIalog Pengesahan -->
    <v-row justify="center">
      <v-dialog
        v-model="dialogPengesahan"
        persistent
        max-width="330"
      >
        <v-card>
          <v-card-text>
          {{$t("Adakah anda pasti untuk mengesahkan?")}}<br><br>
          <strong>{{$t(" HID: "+this.HID)}}</strong>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              @click="dialogPengesahan = false;"
            >
            {{$t('batal')}}
            </v-btn>
            <v-btn
              color="success"
            >
              {{$t('sah')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

      <!-- Error Dialog -->
  <v-dialog
        v-model="errorDialog"
        width="500"
        height="200"
      >
      <v-card>
        <v-alert
          dense
          outlined
          color="#C51162"
          type="error"
        >
        <strong>{{errMessage}}</strong>
        </v-alert>
      </v-card>
  </v-dialog>
  
  <!-- Success Dialog -->
  <v-dialog
        v-model="successDialog"
        max-width="800"
        height="200"
      >
      <v-card
        color="success"
      >
        <v-alert
          dense
          outlined
          color="#C51162"
          type="success"
        >
        <strong>{{successMessage}}</strong>
        </v-alert>
  
        <v-card-actions> 
          <v-spacer></v-spacer>
              <v-btn
                  color="warning"
                  @click='successDialog = false;goTo("1");'
              >
                Batal
              </v-btn>
              <v-btn
                  color="pink"
                  v-show="butangKemaskini"
                  @click='successDialog = false;'
              >
                Kemaskini
              </v-btn>
              <v-btn
                color="primary"
                @click='goTo("2")'
              >
                Pengisian Seterusnya
              </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>


</div>
</template>

<script>
// @ is an alias to /src
import axios from '../../plugins/axios'
//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import maklumatIsiRumah from '@/services/ringkasanMaklumatIsiRumah'
const servicesMaklumatIsiRumah = new maklumatIsiRumah();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();

import i18n from '@/i18n'

export default {

  // components: {
  //   PieChart
  // },
  async beforeMount(){
      this.userData = localStorageData.user();
      // this.namaPOperasiID = localStorageData.po().poid;
      // this.namaPOperasi = localStorageData.po().namapo;
      // this.namaPProsesan = localStorageData.pp().namapp;
      // this.namaPProsesanID = localStorageData.pp().ppid;
      // this.KODNEG = this.userData.kodneg;
      this.role = this.userData.role;

      var dataHID = localStorageData.getHIDdata();
      if(!dataHID){
        this.dialogHID = true;
        //alert("Tiada HID didaftarkan")
      }
    
    this.HID = dataHID.HID;
    this.BNO = dataHID.BNO;
    this.Ps = dataHID.P;
    this.S = dataHID.S;
    //tutup soalan based on sample
      if(this.S == 1){
        this.checkSample = false;
        
      }
      if(this.S == 2){
        this.checkSample = true;
        this.checkSample2 = false;
      }
    this.NG = dataHID.NG;
    this.DP = dataHID.DP;
    this.DB =  dataHID.DB;
    this.BP = dataHID.BP;
    this.ST = dataHID.ST;
    this.NOTK = dataHID.NOTK;
    this.NOIR = dataHID.NOIR;
    this.KAW = dataHID.KAW;
    this.BULAN = dataHID.BULAN;
    this.TAHUN = dataHID.TAHUN;
    this.hubunganIsiRumah = lookupFieldServices.getHubunganDenganKetuaIsiRumah();
    this.getData();
  },
  data: () => ({
    valid:false,
    dialogHID:false,
    dialogDelete: false,
    dialogPengesahan: false,
    noairClick: false,
    disabledOption: false,
    butangSimpanAhliIsiRumah: true,
    disabledPKIR: false,
    checkSample: true,
    checkSample2: false,
    successDialog: false,
    errorDialog: false,
    tahunCarianHID:'',
    HID:'',
    nomborHID:'',
    userData : '',
    role:'',
    publicHIDdata:'',
    kemaskiniNOAIR: "",
    kemaskiniPKIR: "",
    hubunganIsiRumah:'',
    showBorangTambahAhliIsiRumah: false,
    tambahNOAIR : '',
    tambahNama : '',
    tambahPKIR : '',
    successMessage : '',
    selectedNOAIRdata : [],
    noairErrors: [],
    noairSuccess: [],

    rules: {
         required: v => !!v || 'field is required',
         HIDLength: (value) => {
            return (value && value.length == 26) || 'must be 26 digit'
          },
    },


    irData:''
  }),

  methods:{

    async goTo(){
        var res = await publicServices.getBorangByHID(this.nomborHID);
        this.publicHIDdata = res.data.data;
        var setHIDtoLocalStorage = localStorageData.setHID(this.publicHIDdata);
        this.$router.push({name: "JR2"});
    },
    semakanData(){
      this.$router.push({name: "summaryJRB"});
    },
    selectedNOAIR(row) {
      this.noairClick=true;
      this.selectedNOAIRdata = row;
    },
    simpanAhliIsiRumah(){
      this.butangSimpanAhliIsiRumah = true;
       if (this.$refs.form.validate()){

         //////check NOAIR ada 0 depan tak///////////////////////////
          var checktambahNOAIR = this.tambahNOAIR.toString().length;
          if(checktambahNOAIR < 2){
            this.tambahNOAIR = "0"+this.tambahNOAIR;
          }

            servicesMaklumatIsiRumah.simpanAhliIsiRUmah({
              
              HID: this.HID,
              BULAN: this.BULAN,
              TAHUN: this.TAHUN,
              KAW: this.KAW,
              NOAIR : this.tambahNOAIR,
              Nama: this.tambahNama,
              PKIR: this.tambahPKIR.id

            }).then(data =>{

              if(data == "FAILED"){
                this.errorDialog = true;
                this.showBorangTambahAhliIsiRumah = false;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = 'GAGAL MENAMBAH ISI RUMAH';


              }else{
                this.successDialog = true;//paparkan modal mesej
                this.successMessage = data.data.message; //initialize mesej dari API
                this.showBorangTambahAhliIsiRumah = false;
                setTimeout(() => (this.successDialog = false), 2000);//set masa 2 second untuk modal mesej tutup
                setTimeout(() => (window.location.reload()), 1000);//set masa untuk refresh page
              }
             
            })

       }else{
         alert("Sila Isi Semua Medan!");
       }
    },
    testClick(currNOAIRData,option){
      localStorageData.setCurrentNOAIRData(currNOAIRData);
      this.$router.push({name: option});

      if(option == 'JRC'){
        this.$router.push({name: "JRC"});
      }
      if(option == 'HK1'){
        this.$router.push({name: "JRB"});
      }
       if(option == 'HK7'){
        this.$router.push({name: "hk7"});
      }
       if(option == 'HK8'){
        this.$router.push({name: "hk8"});
      }
        if(option == 'JRBpindahan'){
        this.$router.push({name: "JRBpindahan"});
      }
    },
    async padam(id,hid,noair){
      //console.log(hid,noair);

          try {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/maklumatIsiRumah/deleteAhliIsiRumah`, {
                HID:  hid,
                id: id,
                NOAIR: noair,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Dipadam!';
                this.dialogDelete = false;
                this.noairClick=false;
                this.getData();
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
    },
    async getData(){
      this.irData = await servicesMaklumatIsiRumah.getMaklumatIsiRumahByHID(this.HID);
      console.log(this.irData)
    },
    tutupDialogTiadaHID(){
      this.dialogHID = false;
      this.$router.push(`/${i18n.locale}/paparanutama`);
    },
    async submitHID(){
        var res = await publicServices.getBorangByHID(this.nomborHID,this.tahunCarianHID);//dapatkan data HID
        
        if(res.data.status){
          this.publicHIDdata = res.data.data;
          var setHIDtoLocalStorage = localStorageData.setHID(this.publicHIDdata[0]);//setkan data HID ke dalam local storage
          window.location.reload();
        }else{
          //console.log("Not found")
          this.errorDialog = true;
          setTimeout(() => (this.errorDialog = false), 3000);
          this.errMessage = 'HID tidak wujud atau tidak dibenarkan membuat pengisian/pengemaskinian';
        }

    },
    async logKeluar(){
        await axios.get(`${process.env.VUE_APP_API_URL}/auth/logkeluar`)
          // this.localstoragename = await removelocalstorage().then()
          //  this.localstoragename.map(function(value) {
          //   window.localStorage.removeItem(`${value}`);
          // });
        window.localStorage.clear();
        this.$router.push('/')
    },
    userExists(noair){
      return this.irData.dataPER9.some(function(el) {
        return el.NOAIR === noair;
      }); 
    }
    // checkIsItemDisabled(item) {
    //   return (item.id === '01')
    // },
  },
  watch:{
   
    async tambahNOAIR(val) {
      this.butangSimpanAhliIsiRumah = true;
      if (val == "" || val == 0) {
        this.tambahPKIR = '';
        this.butangSimpanAhliIsiRumah = true;
        this.noairErrors = ["RALAT"];
        this.noairSuccess = [];
      } else {

        if(val.length <= 1){
          val = "0"+val;
        }
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/maklumatIsiRumah/checkNOAIR?NOAIR=` + val +`&HID=`+this.HID
        );

        if (res.data.status == "SUCCESS") {
          this.noairErrors = [];
          this.noairSuccess = ["SAH"];
          if(val == '01' || val == '1'){
              this.tambahPKIR = this.hubunganIsiRumah[0];
              this.disabledPKIR = true;
          }else{
            //this.hubunganIsiRumah[0] = {"id":"01","desc":"Ketua isi rumah","disabled":true};
            this.tambahPKIR = '';
            this.disabledPKIR = false;
          }
          
          this.butangSimpanAhliIsiRumah = false;
        } else {
          this.noairErrors = ["RALAT"];
          this.noairSuccess = [];
          this.butangSimpanAhliIsiRumah = true;
        }
      }
    },
  }
}
</script>

<style>
#app{
  /* background: url('https://chatbot.dosm.gov.my/admin/files/dosm/images/chatbot/chatbotlogo.jpg') */
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

.v-btn{
  cursor: pointer;
}
</style>

